module.exports = __webpack_public_path__ + "img/11_119.46280235.png";